<template>
    <input
        ref="input"
        :value="value"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :disabled="disabled"
        :autofocus="autofocus"
        :class="{
            'is-invalid' : $validator.has(validatorName, sid),
            'is-disabled': disabled
        }"
        class="input"
        @input="$emit('input', $event.target.value, $event)"
        @blur="$emit('blur', $event.target.value, $event)"
        @focus="$emit('focus', $event.target.value, $event)"
        @keyup.enter="$emit('enter', $event.target.value, $event)"
    >
</template>

<script>
    export default {
        props: {
            value: {
                validator: value => typeof value === 'string' || typeof value === 'number' || value === null,
                default: null
            },
            sid: {
                type: String,
                default: null
            },
            type: {
                type: String,
                default: 'text'
            },
            name: {
                type: String,
                required: true
            },
            validatorName: {
                type: String,
                required: false,
                default () {
                    return this.name.replace('[', '.').replace(']', '')
                }
            },
            placeholder: {
                type: String,
                default: ''
            },
            autofocus: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            focus () {
                this.$refs.input.focus()
            }
        }
    }
</script>
